'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _projects = require('helpers/projects');

var _AlbumItemPopover = require('../AlbumItemPopover/AlbumItemPopover');

var _AlbumItemPopover2 = _interopRequireDefault(_AlbumItemPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./AlbumMenuButton.scss');

var AlbumMenuButton = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(AlbumMenuButton, _PureComponent);

  function AlbumMenuButton() {
    (0, _classCallCheck3.default)(this, AlbumMenuButton);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumMenuButton.__proto__ || (0, _getPrototypeOf2.default)(AlbumMenuButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumMenuButton, [{
    key: 'bindPopover',
    value: function bindPopover(el) {
      this.popover = el;
    }
  }, {
    key: 'togglePopover',
    value: function togglePopover(e) {
      this.popover.toggle(e);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          album = _props.album,
          className = _props.className,
          iconClass = _props.iconClass,
          onPlay = _props.onPlay,
          onDownloadPress = _props.onDownloadPress,
          onDelete = _props.onDelete;


      return _react2.default.createElement(
        'button',
        { className: (0, _bind2.default)(styles.menuButton, className), onClick: this.togglePopover },
        _react2.default.createElement('i', { className: (0, _bind2.default)(styles.moreDots, iconClass) }),
        _react2.default.createElement(_AlbumItemPopover2.default, {
          id: 'albumPopover_' + album.project_id + '_' + album.recipient_id,
          onInit: this.bindPopover,
          onPlay: onPlay,
          onDownloadPress: onDownloadPress,
          onDelete: onDelete,
          hidePlay: album.audiovideo === _projects.projectTypes.video,
          hidePress: !album.isPress
        })
      );
    }
  }]);
  return AlbumMenuButton;
}(_react.PureComponent), _class2.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string,
  iconClass: _propTypes2.default.string,
  onDelete: _propTypes2.default.func,
  onDownloadPress: _propTypes2.default.func,
  onPlay: _propTypes2.default.func
}, _class2.defaultProps = {
  album: {},
  onDelete: _noop3.default,
  onDownloadPress: _noop3.default,
  onPlay: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'bindPopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'bindPopover'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'togglePopover', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'togglePopover'), _class.prototype)), _class);
exports.default = AlbumMenuButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumMenuButton/AlbumMenuButton.js
// module id = 814
// module chunks = 1